export default __webpack_public_path__ + "static/media/dau.c741ec01.svg";